import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

export default function SocialIconTwitter({ inline }) {
  return (
    <Svg
      style={{
        flex: 1,
        maxWidth: 30,
        maxHeight: 30,
        width: 64,
        height: 64,
      }}
      height="100%"
      width="100%"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
    >
      <Circle cx={256} cy={256} r={256} fill="#1da1f2" />
      <Path
        d="M209.152 391.04c113.536 0 175.616-94.08 175.616-175.616 0-2.688 0-5.376-.128-7.936a126.45 126.45 0 0030.848-32c-11.008 4.864-22.912 8.192-35.456 9.728 12.8-7.68 22.528-19.712 27.136-34.176A124.989 124.989 0 01368 166.016c-11.264-12.032-27.264-19.456-45.056-19.456-34.048 0-61.696 27.648-61.696 61.696 0 4.864.512 9.6 1.664 14.08-51.328-2.56-96.768-27.136-127.232-64.512a61.916 61.916 0 00-8.32 30.976 61.446 61.446 0 0027.52 51.328c-10.112-.256-19.584-3.072-27.904-7.68v.768c0 29.952 21.248 54.784 49.536 60.544a61.529 61.529 0 01-16.256 2.176 58.93 58.93 0 01-11.648-1.152c7.808 24.576 30.592 42.368 57.6 42.88-21.12 16.512-47.744 26.368-76.672 26.368-4.992 0-9.856-.256-14.72-.896 27.008 17.664 59.52 27.904 94.336 27.904"
        fill="#fff"
        fillRule="nonzero"
      />
    </Svg>
  );
}
